// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── CSS Variables ──────────────────────────────────────── */
:root {
  --bg: #0a0f1e;
  --bg-surface: #111827;
  --bg-card: #1a2236;
  --border: #1e2d3d;
  --text: #e2e8f0;
  --text-muted: #8b949e;
  --accent: #60a5fa;
  --accent-soft: rgba(96, 165, 250, 0.10);
  --accent-2: #34d399;
  --nav-bg: rgba(10, 15, 30, 0.70);
  --nav-bg-scrolled: rgba(10, 15, 30, 0.95);
  --shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  --radius: 10px;
}

.light-mode {
  --bg: #f8fafc;
  --bg-surface: #f1f5f9;
  --bg-card: #ffffff;
  --border: #dde3ea;
  --text: #0f172a;
  --text-muted: #64748b;
  --accent: #2563eb;
  --accent-soft: rgba(37, 99, 235, 0.08);
  --accent-2: #059669;
  --nav-bg: rgba(248, 250, 252, 0.70);
  --nav-bg-scrolled: rgba(248, 250, 252, 0.96);
  --shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
}

/* ─── Reset & Base ───────────────────────────────────────── */
*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  background-color: var(--bg);
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Inter", "Roboto", "Helvetica Neue", sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background-color 0.3s ease, color 0.3s ease;
}

code {
  font-family: "SF Mono", "Fira Code", "Cascadia Code", Consolas, monospace;
  font-size: 0.9em;
}

a {
  text-decoration: none;
  color: var(--accent);
  transition: opacity 0.2s ease;
}
a:hover {
  opacity: 0.75;
}

p, h1, h2, h3, h4, h5, h6, span, label, button {
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Inter", "Roboto", "Helvetica Neue", sans-serif;
}

/* ─── Main container ─────────────────────────────────────── */
.main-container {
  min-height: 100vh;
  background-color: var(--bg);
}

/* ─── Shared section layout ──────────────────────────────── */
.section-wrapper {
  padding: 80px 10%;
}
@media (max-width: 768px) {
  .section-wrapper {
    padding: 60px 5%;
  }
}

.section-heading {
  text-align: center;
  margin-bottom: 48px;
}
.section-heading h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
}

.section-rule {
  width: 48px;
  height: 3px;
  background: var(--accent);
  border-radius: 2px;
  margin: 0 auto;
}

/* ─── Navigation ─────────────────────────────────────────── */
.nav-appbar {
  background: var(--nav-bg) !important;
  backdrop-filter: blur(14px) !important;
  -webkit-backdrop-filter: blur(14px) !important;
  border-bottom: 1px solid var(--border) !important;
  box-shadow: none !important;
  transition: background 0.3s ease !important;
}
.nav-appbar.scrolled {
  background: var(--nav-bg-scrolled) !important;
}

.nav-toolbar {
  justify-content: space-between !important;
  padding: 0 5% !important;
  min-height: 64px !important;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  color: var(--text-muted) !important;
  text-decoration: none;
  border: 1px solid var(--border);
  border-radius: 7px;
  padding: 5px 10px;
  transition: color 0.2s, border-color 0.2s, background 0.2s;
}
.nav-logo svg {
  font-size: 1rem !important;
}
.nav-logo:hover {
  color: var(--text) !important;
  border-color: var(--accent);
  background: var(--accent-soft);
  opacity: 1;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 2px;
}

.nav-link-btn {
  color: var(--text-muted) !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  text-transform: none !important;
  padding: 5px 11px !important;
  border-radius: 7px !important;
  border: 1px solid transparent !important;
  transition: color 0.2s, background 0.2s, border-color 0.2s !important;
  min-width: unset !important;
  gap: 5px;
}
.nav-link-btn .MuiButton-startIcon {
  margin-right: 0 !important;
  color: inherit !important;
}
.nav-link-btn:hover {
  color: var(--text) !important;
  background: var(--accent-soft) !important;
  border-color: var(--border) !important;
}
.nav-link-btn.active {
  color: var(--accent) !important;
  background: var(--accent-soft) !important;
  border-color: rgba(96, 165, 250, 0.3) !important;
}

.nav-controls {
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav-icon-btn {
  color: var(--text-muted) !important;
  border-radius: 6px !important;
}
.nav-icon-btn:hover {
  color: var(--text) !important;
  background: var(--accent-soft) !important;
}
.nav-icon-btn svg {
  font-size: 1.1rem !important;
}

.nav-lang-select {
  appearance: none;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-muted);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: border-color 0.2s;
}
.nav-lang-select:hover, .nav-lang-select:focus {
  border-color: var(--accent);
  outline: none;
}
.nav-lang-select option {
  background: var(--bg-surface);
  color: var(--text);
}

.nav-drawer-header {
  padding: 20px 16px 16px;
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text) !important;
  border-bottom: 1px solid var(--border);
}
.nav-drawer-header span {
  color: var(--accent);
}

.nav-drawer-item .MuiListItemButton-root {
  border-radius: 6px !important;
  margin: 2px 8px !important;
  padding: 8px 12px !important;
}
.nav-drawer-item .MuiListItemButton-root:hover {
  background: var(--accent-soft) !important;
}
.nav-drawer-item .MuiListItemText-primary {
  color: var(--text) !important;
  font-size: 0.9rem !important;
  font-weight: 500 !important;
}

/* ─── Scrollbar ──────────────────────────────────────────── */
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: var(--bg);
}

::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,+DAAA;AACA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,uCAAA;EACA,mBAAA;EACA,gCAAA;EACA,yCAAA;EACA,uCAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mCAAA;EACA,4CAAA;EACA,wCAAA;AAAF;;AAGA,+DAAA;AACA;EAAyB,sBAAA;AACzB;;AACA;EACE,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,2GAAA;EAEA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;EACA,uDAAA;AACF;;AAEA;EACE,yEAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,oBAAA;EACA,6BAAA;AACF;AAAE;EAAU,aAAA;AAGZ;;AAAA;EACE,kBAAA;EACA,2GAAA;AAGF;;AACA,+DAAA;AACA;EACE,iBAAA;EACA,2BAAA;AAEF;;AACA,+DAAA;AACA;EACE,iBAAA;AAEF;AAAE;EAHF;IAG8B,gBAAA;EAI5B;AACF;;AAFA;EACE,kBAAA;EACA,mBAAA;AAKF;AAHE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAKJ;;AADA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAIF;;AADA,+DAAA;AACA;EACE,oCAAA;EACA,sCAAA;EACA,8CAAA;EACA,iDAAA;EACA,2BAAA;EACA,2CAAA;AAIF;AAFE;EACE,6CAAA;AAIJ;;AAAA;EACE,yCAAA;EACA,wBAAA;EACA,2BAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;EACA,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,0DAAA;AAGF;AADE;EAAM,0BAAA;AAIR;AAFE;EACE,6BAAA;EACA,2BAAA;EACA,8BAAA;EACA,UAAA;AAIJ;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAGF;;AAAA;EACE,mCAAA;EACA,6BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;EACA,wCAAA;EACA,qEAAA;EACA,2BAAA;EACA,QAAA;AAGF;AADE;EACE,0BAAA;EACA,yBAAA;AAGJ;AAAE;EACE,6BAAA;EACA,yCAAA;EACA,sCAAA;AAEJ;AACE;EACE,+BAAA;EACA,yCAAA;EACA,gDAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,mCAAA;EACA,6BAAA;AAAF;AAEE;EACE,6BAAA;EACA,yCAAA;AAAJ;AAGE;EAAM,4BAAA;AAAR;;AAGA;EACE,gBAAA;EACA,uBAAA;EACA,+BAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,6BAAA;AAAF;AAEE;EACE,2BAAA;EACA,aAAA;AAAJ;AAGE;EACE,6BAAA;EACA,kBAAA;AADJ;;AAKA;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,sCAAA;AAFF;AAIE;EAAO,oBAAA;AADT;;AAKE;EACE,6BAAA;EACA,0BAAA;EACA,4BAAA;AAFJ;AAII;EAAU,yCAAA;AADd;AAIE;EACE,6BAAA;EACA,4BAAA;EACA,2BAAA;AAFJ;;AAMA,+DAAA;AACA;EAAsB,UAAA;AAFtB;;AAGA;EAA4B,qBAAA;AAC5B;;AAAA;EACE,yBAAA;EACA,kBAAA;AAGF;AAFE;EAAU,6BAAA;AAKZ","sourcesContent":["@import \"helpers/colors\";\n\n/* ─── CSS Variables ──────────────────────────────────────── */\n:root {\n  --bg:          #0a0f1e;\n  --bg-surface:  #111827;\n  --bg-card:     #1a2236;\n  --border:      #1e2d3d;\n  --text:        #e2e8f0;\n  --text-muted:  #8b949e;\n  --accent:      #60a5fa;\n  --accent-soft: rgba(96, 165, 250, 0.10);\n  --accent-2:    #34d399;\n  --nav-bg:      rgba(10, 15, 30, 0.70);\n  --nav-bg-scrolled: rgba(10, 15, 30, 0.95);\n  --shadow:      0 8px 32px rgba(0, 0, 0, 0.5);\n  --radius:      10px;\n}\n\n.light-mode {\n  --bg:          #f8fafc;\n  --bg-surface:  #f1f5f9;\n  --bg-card:     #ffffff;\n  --border:      #dde3ea;\n  --text:        #0f172a;\n  --text-muted:  #64748b;\n  --accent:      #2563eb;\n  --accent-soft: rgba(37, 99, 235, 0.08);\n  --accent-2:    #059669;\n  --nav-bg:      rgba(248, 250, 252, 0.70);\n  --nav-bg-scrolled: rgba(248, 250, 252, 0.96);\n  --shadow:      0 8px 32px rgba(0, 0, 0, 0.10);\n}\n\n/* ─── Reset & Base ───────────────────────────────────────── */\n*, *::before, *::after { box-sizing: border-box; }\n\nbody {\n  margin: 0;\n  background-color: var(--bg);\n  color: var(--text);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Inter\", \"Roboto\",\n    \"Helvetica Neue\", sans-serif;\n  font-size: 1rem;\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\ncode {\n  font-family: \"SF Mono\", \"Fira Code\", \"Cascadia Code\", Consolas, monospace;\n  font-size: 0.9em;\n}\n\na {\n  text-decoration: none;\n  color: var(--accent);\n  transition: opacity 0.2s ease;\n  &:hover { opacity: 0.75; }\n}\n\np, h1, h2, h3, h4, h5, h6, span, label, button {\n  color: var(--text);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Inter\", \"Roboto\",\n    \"Helvetica Neue\", sans-serif;\n}\n\n/* ─── Main container ─────────────────────────────────────── */\n.main-container {\n  min-height: 100vh;\n  background-color: var(--bg);\n}\n\n/* ─── Shared section layout ──────────────────────────────── */\n.section-wrapper {\n  padding: 80px 10%;\n\n  @media (max-width: 768px) { padding: 60px 5%; }\n}\n\n.section-heading {\n  text-align: center;\n  margin-bottom: 48px;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    margin: 0 0 12px;\n  }\n}\n\n.section-rule {\n  width: 48px;\n  height: 3px;\n  background: var(--accent);\n  border-radius: 2px;\n  margin: 0 auto;\n}\n\n/* ─── Navigation ─────────────────────────────────────────── */\n.nav-appbar {\n  background: var(--nav-bg) !important;\n  backdrop-filter: blur(14px) !important;\n  -webkit-backdrop-filter: blur(14px) !important;\n  border-bottom: 1px solid var(--border) !important;\n  box-shadow: none !important;\n  transition: background 0.3s ease !important;\n\n  &.scrolled {\n    background: var(--nav-bg-scrolled) !important;\n  }\n}\n\n.nav-toolbar {\n  justify-content: space-between !important;\n  padding: 0 5% !important;\n  min-height: 64px !important;\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.9rem !important;\n  font-weight: 600 !important;\n  color: var(--text-muted) !important;\n  text-decoration: none;\n  border: 1px solid var(--border);\n  border-radius: 7px;\n  padding: 5px 10px;\n  transition: color 0.2s, border-color 0.2s, background 0.2s;\n\n  svg { font-size: 1rem !important; }\n\n  &:hover {\n    color: var(--text) !important;\n    border-color: var(--accent);\n    background: var(--accent-soft);\n    opacity: 1;\n  }\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.nav-link-btn {\n  color: var(--text-muted) !important;\n  font-size: 0.85rem !important;\n  font-weight: 500 !important;\n  text-transform: none !important;\n  padding: 5px 11px !important;\n  border-radius: 7px !important;\n  border: 1px solid transparent !important;\n  transition: color 0.2s, background 0.2s, border-color 0.2s !important;\n  min-width: unset !important;\n  gap: 5px;\n\n  .MuiButton-startIcon {\n    margin-right: 0 !important;\n    color: inherit !important;\n  }\n\n  &:hover {\n    color: var(--text) !important;\n    background: var(--accent-soft) !important;\n    border-color: var(--border) !important;\n  }\n\n  &.active {\n    color: var(--accent) !important;\n    background: var(--accent-soft) !important;\n    border-color: rgba(96, 165, 250, 0.3) !important;\n  }\n}\n\n.nav-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.nav-icon-btn {\n  color: var(--text-muted) !important;\n  border-radius: 6px !important;\n\n  &:hover {\n    color: var(--text) !important;\n    background: var(--accent-soft) !important;\n  }\n\n  svg { font-size: 1.1rem !important; }\n}\n\n.nav-lang-select {\n  appearance: none;\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: border-color 0.2s;\n\n  &:hover, &:focus {\n    border-color: var(--accent);\n    outline: none;\n  }\n\n  option {\n    background: var(--bg-surface);\n    color: var(--text);\n  }\n}\n\n.nav-drawer-header {\n  padding: 20px 16px 16px;\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: var(--text) !important;\n  border-bottom: 1px solid var(--border);\n\n  span { color: var(--accent); }\n}\n\n.nav-drawer-item {\n  .MuiListItemButton-root {\n    border-radius: 6px !important;\n    margin: 2px 8px !important;\n    padding: 8px 12px !important;\n\n    &:hover { background: var(--accent-soft) !important; }\n  }\n\n  .MuiListItemText-primary {\n    color: var(--text) !important;\n    font-size: 0.9rem !important;\n    font-weight: 500 !important;\n  }\n}\n\n/* ─── Scrollbar ──────────────────────────────────────────── */\n::-webkit-scrollbar { width: 5px; }\n::-webkit-scrollbar-track { background: var(--bg); }\n::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 3px;\n  &:hover { background: var(--text-muted); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
